import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import Spinner from "../../Spinner";

const ProductName = ({
    onboarding,
    setOnboarding,
    setPage,
    actualPage,
    setProductsAll,
    boats,
    houses,
}) => {
    const dispatch = useDispatch();
    const [fields, setFields] = useState([]);
    const [siguiente, setSiguiente] = useState("Siguiente");
    const token = localStorage.getItem("token");
    const headers = {
        authorization: token,
    };
    const [inputName, setInputName] = useState(false);
    const [ownerInput, setOwnerInput] = useState("");
    const [owner, setOwner] = useState({
        id: onboarding?.id_propietario || null,
        propietario: onboarding?.propietario || null,
    });
    const debounceInput = useRef(null);
    const debouncePropertyName = useRef(null);
    const authUser = useSelector((state) => state.authReducer);

    useEffect(() => {
        if (boats === "embarcaciones") {
            setOnboarding({
                ...onboarding,
                tipo_producto: "embarcacion",
            });
        }
        if (houses === "casas") {
            setOnboarding({
                ...onboarding,
                tipo_producto: "casa",
            });
        }
    }, []);

    const createProduct = (payload) => {
        setSiguiente(null);
        return async function () {
            if (onboarding.tipo_producto === "casa") {
                const json = await axios.post(
                    `${process.env.REACT_APP_PROXY}/casa/`,
                    payload,
                    { headers }
                );
                const jsonDescripcion = await axios.put(
                    `${process.env.REACT_APP_PROXY}/casa/actualizarDescripcion/${json.data.data.id}`,
                    payload,
                    { headers }
                );

                if (json.data.message === "registro exitoso") {
                    setOnboarding({
                        ...onboarding,
                        id_propietario: json.data.data.id_propietario,
                        id: json.data.data.id,
                    });
                    setPage(actualPage + 1);
                }
            } else {
                const json = await axios.post(
                    `${process.env.REACT_APP_PROXY}/embarcacion/`,
                    payload,
                    { headers }
                );
                const jsonDescripcion = await axios.put(
                    `${process.env.REACT_APP_PROXY}/embarcacion/actualizarDescripcion/${json.data.data.id}`,
                    payload,
                    { headers }
                );

                if (json.data.message === "registro exitoso") {
                    setOnboarding({
                        ...onboarding,
                        id_propietario: json.data.data.id_propietario,
                        id: json.data.data.id,
                    });
                    setPage(actualPage + 1);
                }
            }
        };
    };
    const updateProduct = (payload) => {
        setSiguiente(null);

        return async function () {
            if (onboarding.tipo_producto === "casa") {
                const json = await axios.put(
                    `${process.env.REACT_APP_PROXY}/casa/actualizarNombre/${onboarding.id}`,
                    payload,
                    { headers }
                );
                const jsonDescripcion = await axios.put(
                    `${process.env.REACT_APP_PROXY}/casa/actualizarDescripcion/${onboarding.id}`,
                    payload,
                    { headers }
                );

                const jsonPage = await axios.put(
                    `${process.env.REACT_APP_PROXY}/casa/actualizarPagina/${onboarding.id}`,
                    {
                        numero_pagina: actualPage + 1,
                    },
                    { headers }
                );

                if (json.data.message === "actuaizacion exitoso") {
                    setOnboarding({
                        ...onboarding,
                        nombre: json.data.data.nombre,
                    });
                    setPage(actualPage + 1);
                }
            }
            if (onboarding.tipo_producto === "embarcacion") {
                const json = await axios.put(
                    `${process.env.REACT_APP_PROXY}/embarcacion/actualizarNombre/${onboarding.id}`,
                    payload,
                    { headers }
                );
                const jsonDescripcion = await axios.put(
                    `${process.env.REACT_APP_PROXY}/embarcacion/actualizarDescripcion/${onboarding.id}`,
                    payload,
                    { headers }
                );
                const jsonPage = await axios.put(
                    `${process.env.REACT_APP_PROXY}/embarcacion/actualizarPagina/${onboarding.id}`,
                    {
                        numero_pagina: actualPage + 1,
                    },
                    { headers }
                );

                if (json.data.message === "actuaizacion exitoso") {
                    setOnboarding({
                        ...onboarding,
                        nombre: json.data.data.nombre,
                    });
                    setPage(actualPage + 1);
                }
            }
        };
    };

    const nextPage = async () => {
        const { data } = await axios.post(
            `${process.env.REACT_APP_PROXY}/${onboarding.tipo_producto}/getNombre`,
            {
                nombre: onboarding.nombre,
                id: onboarding.id,
            },
            { headers }
        );
        if (data === "No disponible") {
            return Swal.fire({
                title: "Ya existe una propiedad con ese nombre",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Completar!",
            });
        }
        if (authUser.tipo_usuario === 3) {
            if (onboarding.nombre && onboarding.descripcion) {
                if (!onboarding.id) {
                    dispatch(
                        createProduct({
                            nombre: onboarding.nombre,
                            descripcion: onboarding.descripcion,
                            id_propietario: authUser.id_usuario,
                            id: onboarding.id,
                        })
                    );
                } else {
                    dispatch(
                        updateProduct({
                            nombre: onboarding.nombre,
                            descripcion: onboarding.descripcion,
                            id_propietario: authUser.id_usuario,
                            id: onboarding.id,
                        })
                    );
                }
            } else {
                alert();
            }
        } else if (authUser.tipo_usuario === 4) {
            if (onboarding.nombre && onboarding.descripcion) {
                if (!onboarding.id) {
                    dispatch(
                        createProduct({
                            nombre: onboarding.nombre,
                            descripcion: onboarding.descripcion,
                            id_propietario: authUser.id_propietario,
                            id: onboarding.id,
                        })
                    );
                } else {
                    dispatch(
                        updateProduct({
                            nombre: onboarding.nombre,
                            descripcion: onboarding.descripcion,
                            id_propietario: authUser.id_propietario,
                            id: onboarding.id,
                        })
                    );
                }
            } else {
                alert();
            }
        } else {
            if (
                onboarding.nombre &&
                onboarding.descripcion &&
                owner.id !== null
            ) {
                if (!onboarding.id) {
                    dispatch(
                        createProduct({
                            nombre: onboarding.nombre,
                            descripcion: onboarding.descripcion,
                            id_propietario: owner.id,
                            id: owner.id,
                        })
                    );
                } else {
                    dispatch(
                        updateProduct({
                            nombre: onboarding.nombre,
                            descripcion: onboarding.descripcion,
                            id_propietario: owner.id,
                            id: owner.id,
                        })
                    );
                }
            } else {
                alertAdministrativo();
            }
        }
    };

    const alertAdministrativo = () => {
        Swal.fire({
            title: "Debes ingresar un nombre, una descripcion y un propietario",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Completar!",
        });
    };

    const alert = () => {
        Swal.fire({
            title: "Debes ingresar un nombre y una descripcion",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Completar!",
        });
    };

    const handleInputChange = (e) => {
        if (e.target.name === "ownerName") {
            setOwner({
                id: null,
                propietario: e.target.value,
            });
            if (debounceInput.current) clearTimeout(debounceInput.current);
            if (e.target.value === "") {
                setFields([]);
            }
            debounceInput.current = setTimeout(async () => {
                const { data } = await axios(
                    `${process.env.REACT_APP_PROXY}/propietario/autocomplete?autocomplete=${e.target.value}`,
                    { headers }
                );
                setFields(data);
            }, 500);
        } else {
            if (debouncePropertyName.current)
                clearTimeout(debouncePropertyName.current);
            if (e.target.value === "") {
                setInputName(false);
            }
            debouncePropertyName.current = setTimeout(async () => {
                const { data } = await axios.post(
                    `${process.env.REACT_APP_PROXY}/${onboarding.tipo_producto}/getNombre`,
                    {
                        nombre: e.target.value,
                        id: onboarding.id ? onboarding.id : 0,
                    },
                    { headers }
                );

                if (data === "No disponible") {
                    setInputName("¡Nombre de propiedad no disponible!");
                } else if (data === "Disponible")
                    setInputName("¡Nombre disponible!");
            }, 500);
        }
    };

    const handleBlur = () => {
        setTimeout(() => {
            setFields([]);
        }, 200);
    };

    return (
        <div className="w-full">
            <div className="w-full h-screen  md723:grid  md723:grid-cols-2">
                <div className="bg-[#053465] h-1/3 md723:h-screen  relative">
                    <div className="flex items-center justify-center h-full ">
                        <div className="mt-7 ml-8 top-0 left-0 absolute hidden md723:block">
                            <svg
                                width="56"
                                height="56"
                                viewBox="0 0 56 56"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1925 14.2294 24.8752 13.9419 24.6437C13.6563 24.4123 13.2699 24.2984 12.7846 24.2984H11.1288V26.9323H12.7379C13.0571 26.9323 13.339 26.88 13.5854 26.7736ZM14.7726 30.3128C14.7726 30.0029 14.6998 29.736 14.5542 29.512C14.4086 29.288 14.2032 29.1125 13.9382 28.9893C13.6712 28.8661 13.3539 28.8045 12.9806 28.8045H11.1307V31.668H12.9283C13.5592 31.668 14.024 31.5485 14.3246 31.3096C14.6214 31.0707 14.7726 30.7384 14.7726 30.3128ZM47.8798 31.3749C47.624 31.892 47.2712 32.3624 46.8251 32.7861C46.379 33.2099 45.8358 33.5477 45.1955 33.7979C44.5552 34.048 43.8216 34.1731 42.9947 34.1731C41.9064 34.1731 40.932 33.9323 40.0734 33.4544C39.2128 32.9747 38.5352 32.2765 38.0387 31.3563C37.5422 30.4379 37.292 29.3179 37.292 28C37.292 26.6784 37.544 25.5565 38.0499 24.6381C38.5558 23.7197 39.239 23.0197 40.0995 22.5437C40.9619 22.0659 41.927 21.8288 42.9947 21.8288C43.7227 21.8288 44.3966 21.9296 45.0163 22.1312C45.6342 22.3328 46.1792 22.6259 46.6496 23.0104C47.12 23.3968 47.5008 23.8691 47.7958 24.4291C48.0888 24.9891 48.2718 25.6275 48.3427 26.348H45.4064C45.3672 26.0475 45.287 25.7749 45.1656 25.5323C45.0443 25.2896 44.8838 25.0824 44.684 24.9107C44.4843 24.7389 44.2491 24.6064 43.9766 24.5149C43.704 24.4235 43.4035 24.3768 43.075 24.3768C42.4907 24.3768 41.9886 24.5187 41.5686 24.8061C41.1486 25.0917 40.8256 25.5043 40.5998 26.0437C40.3758 26.5832 40.2619 27.2365 40.2619 28.0037C40.2619 28.8008 40.3758 29.4691 40.6054 30.0067C40.835 30.5443 41.1579 30.9493 41.5742 31.2219C41.9923 31.4944 42.4851 31.6288 43.0582 31.6288C43.3792 31.6288 43.6723 31.5877 43.9355 31.5056C44.2006 31.4235 44.432 31.304 44.6336 31.1453C44.8352 30.9867 45.0014 30.7925 45.1339 30.5648C45.2646 30.3352 45.356 30.0776 45.4064 29.7864L48.3427 29.8032C48.2904 30.3333 48.1355 30.8579 47.8798 31.3749ZM27.9998 51.5088C21.5019 51.5088 15.62 48.8787 11.3603 44.6227L27.9998 28L11.3603 11.3773C15.62 7.12134 21.5019 4.49121 27.9998 4.49121C34.4976 4.49121 40.3795 7.12321 44.6392 11.3773L27.9998 28L44.6392 44.6227C40.3795 48.8787 34.4976 51.5088 27.9998 51.5088ZM8.22244 34.0088V21.9912H13.2382C14.1398 21.9912 14.8939 22.1181 15.5024 22.372C16.111 22.6277 16.5683 22.9824 16.8763 23.4397C17.1843 23.8971 17.3374 24.4272 17.3374 25.0301C17.3374 25.4875 17.2422 25.8963 17.0499 26.2528C16.8576 26.6112 16.5944 26.908 16.2566 27.1413C15.9206 27.3765 15.5304 27.5408 15.088 27.6341V27.7517C15.5734 27.776 16.0232 27.9067 16.4358 28.1456C16.8502 28.3845 17.1806 28.7168 17.4326 29.1405C17.6827 29.5661 17.8078 30.0683 17.8078 30.6451C17.8078 31.2909 17.6435 31.8659 17.315 32.3736C16.9864 32.8795 16.5104 33.2789 15.887 33.5701C15.2635 33.8613 14.5094 34.0069 13.619 34.0069H8.22244V34.0088ZM27.9998 0.959473C13.0515 0.959473 0.933105 13.0648 0.933105 28C0.933105 42.9333 13.0515 55.0405 27.9998 55.0405C42.948 55.0405 55.0664 42.9333 55.0664 28C55.0664 13.0648 42.948 0.959473 27.9998 0.959473ZM13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1925 14.2294 24.8752 13.9419 24.6437C13.6563 24.4123 13.2699 24.2984 12.7846 24.2984H11.1288V26.9323H12.7379C13.0571 26.9323 13.339 26.88 13.5854 26.7736ZM14.5542 29.5101C14.4086 29.2861 14.2032 29.1107 13.9382 28.9875C13.6712 28.8643 13.3539 28.8027 12.9806 28.8027H11.1307V31.6661H12.9283C13.5592 31.6661 14.024 31.5467 14.3246 31.3077C14.6232 31.0688 14.7744 30.7365 14.7744 30.3109C14.7726 30.0029 14.6998 29.736 14.5542 29.5101ZM14.5542 29.5101C14.4086 29.2861 14.2032 29.1107 13.9382 28.9875C13.6712 28.8643 13.3539 28.8027 12.9806 28.8027H11.1307V31.6661H12.9283C13.5592 31.6661 14.024 31.5467 14.3246 31.3077C14.6232 31.0688 14.7744 30.7365 14.7744 30.3109C14.7726 30.0029 14.6998 29.736 14.5542 29.5101ZM13.9438 24.6437C13.6582 24.4123 13.2718 24.2984 12.7864 24.2984H11.1307V26.9323H12.7398C13.0571 26.9323 13.339 26.88 13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1907 14.2294 24.8752 13.9438 24.6437Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <svg
                            onClick={() => (setPage(0), setProductsAll(true))}
                            className="rounded-full hover:bg-gray-600 hover:text-white text-white font-medium mt-7 ml-7 text-base top-0 left-0 absolute md723:hidden"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18 6L6 18"
                                stroke="currentColor"
                                strokeWidth="1.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M6 6L18 18"
                                stroke="currentColor"
                                strokeWidth="1.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>

                        <div className="text-center md723:top-auto absolute  bottom-14 md723:bottom-auto ">
                            <p className="text-white font-bold text-2xl md723:text-3xl lg1170:text-5xl lg:text-4xl px-3 ">
                                Ponle un nombre a tu
                            </p>
                            <p className="text-white font-bold text-2xl md723:text-3xl lg1170:text-5xl lg:text-4xl px-3 mt-3">
                                {onboarding.tipo_producto === "casa"
                                    ? " alojamiento "
                                    : " embarcación "}
                                y{" "}
                                {onboarding.tipo_producto === "casa"
                                    ? " descríbelo "
                                    : " descríbela "}{" "}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex md723:items-center justify-center h-2/3  md723:h-screen md723:relative">
                    <div className="">
                        <div className="text-right hidden md723:block">
                            <p
                                onClick={() => (
                                    setPage(0), setProductsAll(true)
                                )}
                                className="text-[#053465] font-medium mt-7 mr-10 text-base top-0 right-0 absolute cursor-pointer ">
                                Salir
                            </p>
                        </div>
                        <div className="h-[50vh] md723:h-[70vh] overflow-hidden">
                            <div className="h-[50vh] md723:h-[70vh] overflow-auto w-[105%]">
                                <div className="pt-10">
                                    {inputName && (
                                        <h1
                                            className={`${
                                                inputName ===
                                                "¡Nombre de propiedad no disponible!"
                                                    ? "text-red-600"
                                                    : "text-green-600"
                                            } text-xs  font-semibold`}>
                                            {inputName}
                                        </h1>
                                    )}
                                    <div className="w-[95%] mt-3 ">
                                        <label className=" text-base text-black">
                                            Nombre
                                        </label>

                                        <input
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                setOnboarding({
                                                    ...onboarding,
                                                    nombre: e.target.value,
                                                });
                                            }}
                                            value={onboarding?.nombre}
                                            autoComplete="off"
                                            type={"text"}
                                            placeholder="Ejm: Casa La Pradera"
                                            className="w-full border my-3 bg-transparent rounded-lg py-3 px-3 outline-none focus:outline-none placeholder:text-[#3C3C3C]/70 placeholder:font-bold"
                                        />
                                    </div>

                                    <div className="w-[95%] mt-3 ">
                                        <label className=" text-base text-black">
                                            Descripción
                                        </label>

                                        <textarea
                                            onChange={(e) =>
                                                setOnboarding({
                                                    ...onboarding,
                                                    descripcion: e.target.value,
                                                })
                                            }
                                            value={onboarding.descripcion}
                                            placeholder="Ejm: Hermosa y amplia casa de campo ubicada en chaclacayo."
                                            className="w-full h-40 border my-3 bg-transparent rounded-lg py-3 px-3 outline-none focus:outline-none placeholder:text-[#3C3C3C]/70 placeholder:font-bold placeholder:text-left"
                                        />
                                    </div>
                                    {authUser.tipo_usuario !== 3 &&
                                        authUser.tipo_usuario !== 4 && (
                                            <div className="w-[95%] mb-5">
                                                <h1 className="text-base text-black">
                                                    Nombre del propietario
                                                </h1>

                                                <input
                                                    autoComplete="off"
                                                    type="text"
                                                    onBlur={handleBlur}
                                                    value={owner.propietario}
                                                    name="ownerName"
                                                    onChange={handleInputChange}
                                                    placeholder="Ingrese el nombre del propietario"
                                                    className="w-full border my-3 bg-transparent rounded-lg py-3 px-3 outline-none focus:outline-none placeholder:text-[#3C3C3C]/70 placeholder:font-bold"
                                                />

                                                <div className="-mt-4">
                                                    {fields.length > 0 &&
                                                        fields.map((owner) => (
                                                            <div
                                                                key={owner.id}
                                                                className="w-full border my-3 bg-transparent rounded-lg py-3 px-3 outline-none focus:outline-none placeholder:text-[#3C3C3C]/70 placeholder:font-bold cursor-pointer"
                                                                onClick={() => {
                                                                    setOwner({
                                                                        id: owner.id,
                                                                        propietario:
                                                                            owner.propietario,
                                                                    });
                                                                    setOwnerInput(
                                                                        owner.propietario
                                                                    );
                                                                    setFields(
                                                                        []
                                                                    );
                                                                }}>
                                                                {
                                                                    owner.propietario
                                                                }
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>

                            <div className="h-1 w-2/12 bg-[#053465] xs:bottom-0 xs:mb-[87px]   mt-3 absolute left-0"></div>
                            <div className="border-t border-[#3C3C3C] flex justify-between items-center w-full xs:bottom-0 xs:mb-2 mt-4 absolute left-0 xs:py-3">
                                <div
                                    onClick={() => setPage(actualPage - 1)}
                                    className="text-blue-bluecorner border border-blue-bluecorner mx-5 px-6 py-3 rounded-lg mt-2 cursor-pointer hover:bg-blue-bluecorner hover:text-white">
                                    Atrás
                                </div>
                                <div
                                    disabled={!siguiente}
                                    onClick={() => nextPage()}
                                    className="text-blue-bluecorner border border-blue-bluecorner mx-5 px-4 py-3 rounded-lg mt-2 cursor-pointer hover:bg-blue-bluecorner hover:text-white">
                                    {siguiente ? (
                                        siguiente
                                    ) : (
                                        <Spinner width={5} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductName;
